/* tslint:disable */
/* eslint-disable */
/**
 * Azimut - BIL to NFE-DATAHUB
 * API Definition for Azimut - BIL to NFE-DATAHUB
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: az.tech.datahub@reply.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface ComponenteTeam
 */
export interface ComponenteTeam {
    /**
     * 
     * @type {string}
     * @memberof ComponenteTeam
     */
    'codAgente'?: string;
    /**
     * 
     * @type {string}
     * @memberof ComponenteTeam
     */
    'tipoAgente'?: ComponenteTeamTipoAgenteEnum;
    /**
     * 
     * @type {string}
     * @memberof ComponenteTeam
     */
    'nomeAgente'?: string;
    /**
     * 
     * @type {string}
     * @memberof ComponenteTeam
     */
    'cognomeAgente'?: string;
}

export const ComponenteTeamTipoAgenteEnum = {
    Cf: 'CF',
    Team: 'TEAM'
} as const;

export type ComponenteTeamTipoAgenteEnum = typeof ComponenteTeamTipoAgenteEnum[keyof typeof ComponenteTeamTipoAgenteEnum];

/**
 * 
 * @export
 * @interface Metadata
 */
export interface Metadata {
    /**
     * 
     * @type {string}
     * @memberof Metadata
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof Metadata
     */
    'updatedAt'?: string;
}
/**
 * 
 * @export
 * @interface Pagination
 */
export interface Pagination {
    /**
     * 
     * @type {number}
     * @memberof Pagination
     */
    'count'?: number;
    /**
     * 
     * @type {number}
     * @memberof Pagination
     */
    'per_page'?: number;
    /**
     * 
     * @type {number}
     * @memberof Pagination
     */
    'page'?: number;
}
/**
 * 
 * @export
 * @interface RicercaCFdaClienteInner
 */
export interface RicercaCFdaClienteInner {
    /**
     * 
     * @type {string}
     * @memberof RicercaCFdaClienteInner
     */
    'codAgente'?: string;
    /**
     * 
     * @type {string}
     * @memberof RicercaCFdaClienteInner
     */
    'tipoAgente'?: RicercaCFdaClienteInnerTipoAgenteEnum;
    /**
     * 
     * @type {string}
     * @memberof RicercaCFdaClienteInner
     */
    'codGerarchia'?: RicercaCFdaClienteInnerCodGerarchiaEnum;
    /**
     * 
     * @type {string}
     * @memberof RicercaCFdaClienteInner
     */
    'nomeAgente'?: string;
    /**
     * 
     * @type {string}
     * @memberof RicercaCFdaClienteInner
     */
    'cognomeAgente'?: string;
    /**
     * 
     * @type {string}
     * @memberof RicercaCFdaClienteInner
     */
    'denominazioneAgente'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof RicercaCFdaClienteInner
     */
    'isPrincipale'?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof RicercaCFdaClienteInner
     */
    'listaDossier'?: Array<string>;
    /**
     * 
     * @type {Array<ComponenteTeam>}
     * @memberof RicercaCFdaClienteInner
     */
    'componentiTeam'?: Array<ComponenteTeam>;
}

export const RicercaCFdaClienteInnerTipoAgenteEnum = {
    Cf: 'CF',
    Team: 'TEAM'
} as const;

export type RicercaCFdaClienteInnerTipoAgenteEnum = typeof RicercaCFdaClienteInnerTipoAgenteEnum[keyof typeof RicercaCFdaClienteInnerTipoAgenteEnum];
export const RicercaCFdaClienteInnerCodGerarchiaEnum = {
    Rete: 'RETE'
} as const;

export type RicercaCFdaClienteInnerCodGerarchiaEnum = typeof RicercaCFdaClienteInnerCodGerarchiaEnum[keyof typeof RicercaCFdaClienteInnerCodGerarchiaEnum];

/**
 * 
 * @export
 * @interface RicercaCFdaClienteResponse
 */
export interface RicercaCFdaClienteResponse {
    /**
     * 
     * @type {Metadata}
     * @memberof RicercaCFdaClienteResponse
     */
    'metadata'?: Metadata;
    /**
     * 
     * @type {Array<RicercaCFdaClienteInner>}
     * @memberof RicercaCFdaClienteResponse
     */
    'data'?: Array<RicercaCFdaClienteInner>;
    /**
     * 
     * @type {Pagination}
     * @memberof RicercaCFdaClienteResponse
     */
    'pagination'?: Pagination;
}

/**
 * AnagraficaApi - axios parameter creator
 * @export
 */
export const AnagraficaApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Api per la ricerca dei clienti con AML scaduto o in scadenza.
         * @summary Ricerca elenco dei CF associati ad un cliente
         * @param {string} codCliente codice cliente
         * @param {'RETE'} codGerarchia codice gerarchia dell\&#39;agente (o codice canale rete)
         * @param {number} perPage numero di oggetti per pagina
         * @param {number} page numero della pagina da mostrare
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        anagraficaV2RicercaCFdaClienteGet: async (codCliente: string, codGerarchia: 'RETE', perPage: number, page: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'codCliente' is not null or undefined
            assertParamExists('anagraficaV2RicercaCFdaClienteGet', 'codCliente', codCliente)
            // verify required parameter 'codGerarchia' is not null or undefined
            assertParamExists('anagraficaV2RicercaCFdaClienteGet', 'codGerarchia', codGerarchia)
            // verify required parameter 'perPage' is not null or undefined
            assertParamExists('anagraficaV2RicercaCFdaClienteGet', 'perPage', perPage)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('anagraficaV2RicercaCFdaClienteGet', 'page', page)
            const localVarPath = `/anagrafica/v2/ricercaCFdaCliente`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (codCliente !== undefined) {
                localVarQueryParameter['codCliente'] = codCliente;
            }

            if (codGerarchia !== undefined) {
                localVarQueryParameter['codGerarchia'] = codGerarchia;
            }

            if (perPage !== undefined) {
                localVarQueryParameter['per_page'] = perPage;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AnagraficaApi - functional programming interface
 * @export
 */
export const AnagraficaApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AnagraficaApiAxiosParamCreator(configuration)
    return {
        /**
         * Api per la ricerca dei clienti con AML scaduto o in scadenza.
         * @summary Ricerca elenco dei CF associati ad un cliente
         * @param {string} codCliente codice cliente
         * @param {'RETE'} codGerarchia codice gerarchia dell\&#39;agente (o codice canale rete)
         * @param {number} perPage numero di oggetti per pagina
         * @param {number} page numero della pagina da mostrare
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async anagraficaV2RicercaCFdaClienteGet(codCliente: string, codGerarchia: 'RETE', perPage: number, page: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RicercaCFdaClienteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.anagraficaV2RicercaCFdaClienteGet(codCliente, codGerarchia, perPage, page, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AnagraficaApi - factory interface
 * @export
 */
export const AnagraficaApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AnagraficaApiFp(configuration)
    return {
        /**
         * Api per la ricerca dei clienti con AML scaduto o in scadenza.
         * @summary Ricerca elenco dei CF associati ad un cliente
         * @param {string} codCliente codice cliente
         * @param {'RETE'} codGerarchia codice gerarchia dell\&#39;agente (o codice canale rete)
         * @param {number} perPage numero di oggetti per pagina
         * @param {number} page numero della pagina da mostrare
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        anagraficaV2RicercaCFdaClienteGet(codCliente: string, codGerarchia: 'RETE', perPage: number, page: number, options?: any): AxiosPromise<RicercaCFdaClienteResponse> {
            return localVarFp.anagraficaV2RicercaCFdaClienteGet(codCliente, codGerarchia, perPage, page, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for anagraficaV2RicercaCFdaClienteGet operation in AnagraficaApi.
 * @export
 * @interface AnagraficaApiAnagraficaV2RicercaCFdaClienteGetRequest
 */
export interface AnagraficaApiAnagraficaV2RicercaCFdaClienteGetRequest {
    /**
     * codice cliente
     * @type {string}
     * @memberof AnagraficaApiAnagraficaV2RicercaCFdaClienteGet
     */
    readonly codCliente: string

    /**
     * codice gerarchia dell\&#39;agente (o codice canale rete)
     * @type {'RETE'}
     * @memberof AnagraficaApiAnagraficaV2RicercaCFdaClienteGet
     */
    readonly codGerarchia: 'RETE'

    /**
     * numero di oggetti per pagina
     * @type {number}
     * @memberof AnagraficaApiAnagraficaV2RicercaCFdaClienteGet
     */
    readonly perPage: number

    /**
     * numero della pagina da mostrare
     * @type {number}
     * @memberof AnagraficaApiAnagraficaV2RicercaCFdaClienteGet
     */
    readonly page: number
}

/**
 * AnagraficaApi - object-oriented interface
 * @export
 * @class AnagraficaApi
 * @extends {BaseAPI}
 */
export class AnagraficaApi extends BaseAPI {
    /**
     * Api per la ricerca dei clienti con AML scaduto o in scadenza.
     * @summary Ricerca elenco dei CF associati ad un cliente
     * @param {AnagraficaApiAnagraficaV2RicercaCFdaClienteGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnagraficaApi
     */
    public anagraficaV2RicercaCFdaClienteGet(requestParameters: AnagraficaApiAnagraficaV2RicercaCFdaClienteGetRequest, options?: AxiosRequestConfig) {
        return AnagraficaApiFp(this.configuration).anagraficaV2RicercaCFdaClienteGet(requestParameters.codCliente, requestParameters.codGerarchia, requestParameters.perPage, requestParameters.page, options).then((request) => request(this.axios, this.basePath));
    }
}


